import React from "react";
import { SettingCheckBox, SettingsHeader } from "../Settings";
import "./../Setting.scss";
import "./Chat.scss";
import { DropdownArrowHoc } from "../../../../assets/images";
import { InfoIcon } from "../images"
import {
    blockOfflineAction,
    getLocalWebsettings,
    isAppOnline,
    setLocalWebsettings,
} from "../../../../Helpers/Utility";
import { useSelector } from "react-redux";
import OutsideClickHandler from "react-outside-click-handler";
import { store } from "../../../../Redux/store";
import { webLocalStorageSetting } from "../../../../Redux/feature/webLocalStorageSettingDataSlice";

const Chat = (props = {}) => {
    const globalStoteData = useSelector((state) => state || {});
    const {
        translateLanguage: {
            translateLanguages = [],
        },
        webLocalStorageSetting: { isEnableArchived } = {},
    } = globalStoteData;
    const {
        handleBackToSetting,
        setSelectedLaun = "English",
        featureStateData: { isTranslationEnabled = false } = {},
    } = props;
    const [enableTranslate, setEnableTranslate] = React.useState(false);
    const [language, setLaunguage] = React.useState(setSelectedLaun);
    const [showDrop, setshowDrop] = React.useState(false);
    const [translate, setTranslate] = React.useState(false);
    /**
    // const [boxedLayout, setBoxedLayout] = React.useState(false);
    */

    React.useEffect(() => {
        const webSettings = getLocalWebsettings();
        if (webSettings && Object.keys(webSettings).length) {
            if (isTranslationEnabled) {
                setEnableTranslate(webSettings.translate || false);
                setTranslate(webSettings.translate || false);
                setLocalWebsettings("translate", webSettings.translate || false);
            } else {
                setEnableTranslate(false);
                setTranslate(false);
                setLocalWebsettings("translate", false);
            }
            /**
            // setBoxedLayout(webSettings.boxLayout || false);
            */
            if (isTranslationEnabled) {
                store.dispatch(
                    webLocalStorageSetting({
                        translate: webSettings.translate || false,
                        isEnableArchived: webSettings.archive,
                    })
                );
            } else {
                store.dispatch(
                    webLocalStorageSetting({
                        translate: false,
                        isEnableArchived: webSettings.archive,
                    })
                );
            }
        }
    }, []);

    React.useEffect(() => {
        setLaunguage(setSelectedLaun);
    }, [setSelectedLaun]);

    React.useEffect(() => {
        setLocalWebsettings("translate", translate);
        setEnableTranslate(translate);
    }, [translate]);

    const handleTranslationState = (value) => {
        if (blockOfflineAction()) return;
        setTranslate(value);
        store.dispatch(
            webLocalStorageSetting({
                translate: value,
                isEnableArchived: isEnableArchived,
            })
        );
        setLocalWebsettings("translate", value);
        setEnableTranslate(value);
    };

    const handleLanguage = (value) => {
        setLocalWebsettings("translateLang", value.language);
        setLaunguage(value.name);
        setshowDrop(false);
    };
    const outsidePopupClick = () => {
        setshowDrop(false);
    };

    const handleDrop = (event = {}) => {
        if (blockOfflineAction()) return;
        setshowDrop(true);
    };

    const searchLanguage = (e = {}) => {
        const value = e?.target?.value;
        setLaunguage(value);
        if(value.length > 0) setshowDrop(true);
        const search = value.toLowerCase();
        const translateLanguage = document.querySelectorAll("li.language");
        for (const i of translateLanguage) {
            const item = i.innerHTML.toLowerCase();
            if (item.indexOf(search) === -1) {
                i.style.display = "none";
            } else {
                i.style.display = "block";
            }
        }
    };
    return (
        <div className="setting-container">
            <div>
                <div className="settinglist">
                    <SettingsHeader
                        handleBackFromSetting={handleBackToSetting}
                        label={"Chat"}
                    />
                    <ul className="setting-list-ul chat-setting">
                        {/** {config.boxLayout && (
                            <BoxedLayout
                                dafaultValue={boxedLayout}
                                id={"boxedLayout"}
                                label={"Boxed View"}
                            />
                        )} */}
                        {isTranslationEnabled && (
                            <SettingCheckBox
                                getaAtion={handleTranslationState}
                                chat={true}
                                dafaultSetting={translate}
                                id={"chat-setting"}
                                label={"Translate Message"}
                            >
                                <span className="label-info">
                                    Enable Translate Message to choose Translation Language
                                </span>
                                {enableTranslate && (
                                    <div className="language-select">
                                        <h4>Choose Translation Language</h4>
                                        <div
                                            onClick={(e) => handleDrop(e)}
                                            className={
                                                showDrop ? "defaultSelected active" : "defaultSelected"
                                            }
                                        >
                                            <input
                                                placeholder="Select any language"
                                                readOnly={!isAppOnline() ? true : false}
                                                onChange={(e) =>
                                                    !blockOfflineAction() ? searchLanguage(e) : null
                                                }
                                                value={language}
                                            />
                                            <DropdownArrowHoc viewBox="0 0 11.926 6.566"/>
                                        </div>
                                        <OutsideClickHandler
                                            onOutsideClick={() => outsidePopupClick()}
                                        >
                                            <div className="drop-wrapper">
                                                {showDrop && (
                                                    <div>
                                                        <ul className="drop-option">
                                                            {translateLanguages.map((lang) => (
                                                                <li className="language" key={lang.name}>
                                                                    <button onClick={() => handleLanguage(lang)}>
                                                                        {lang.name}
                                                                    </button>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                )}
                                            </div>
                                        </OutsideClickHandler>
                                        <p className="info">
                                            <i>
                                                <InfoIcon viewBox="0 0 18.625 18.625"/>
                                            </i>
                                            <span>
                                                Mouse over received message chat bubble which displays
                                                Translate Message icon,{" "}
                                                <strong>"Click it to translate the message"</strong>
                                            </span>
                                        </p>
                                    </div>
                                )}
                            </SettingCheckBox>
                        )}
                    </ul>
                </div>
            </div>
        </div>
    );
};
export default Chat;
